import { RouteRecordRaw,
// eslint-disable-next-line @typescript-eslint/no-unused-vars
RouterView } from 'vue-router';
import { RouteName } from '@/enums/RouteName.enum';
import { RoutePath } from '@/enums/RoutePath.eunm';
import { t } from '@/utils/utils';

import Map from '@/views/Map.vue';

export const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		redirect: `/${RoutePath.MAP}`,
	},
	{
		path: `/${RoutePath.MAP}`,
		name: RouteName.MAP,
		component: Map,
		props: (route) => ({ params: route.query }),
		meta: {
			title: t('nav.map'),
		},
	},
];
